var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/requestHook';
import { shippingInstruction as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { FormikTextField as OriginalFormikTextField } from '../../atoms/TextField';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { camelize, capitalize } from '../../../utils/camelize';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import OriginalFormikDatePicker from '../../atoms/FormikDatePicker';
import withDefaultProps from '../../../utils/withDefaultProps';
import StatusTag from '../../atoms/StatusTag';
import { useConfirm } from '../../../hooks/confirmationHook';
var REQUIRED_FIELDS = [
    'status',
    'date_of_issue',
    'port_of_loading',
    'port_of_discharge',
    'freight',
    'freight_for_invoice_or_packing_list',
    'description_of_goods',
    'country_of_origin',
    'crop',
    'expiration_date',
    'shipment',
    'incoterms',
    'payment',
    'insurance',
    'date_of_packing',
    'shipper_company_name',
    'shipper_company_name',
    'shipper_contact_name',
    'shipper_address',
    'shipper_phone_number',
    'shipper_email',
    'consignee_company_name',
    'consignee_contact_name',
    'consignee_address',
    'consignee_phone_number',
    'consignee_email',
    'consignee_tax_id_text',
    'notify_party_company_name',
    'notify_party_contact_name',
    'notify_party_address',
    'notify_party_phone_number',
    'notify_party_email',
    'notify_party_tax_id_text',
    'required_documents',
    'bag_marks',
];
var ShippingInstructionForm = function (_a) {
    var editable = _a.editable, shippingInstruction = _a.shippingInstruction, onChange = _a.onChange;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var update = useRequest(api.update);
    var confirm = useConfirm();
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, update({
                            id: shippingInstruction.id,
                            shipping_instruction: values,
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onChange(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, shippingInstruction, update, notify, onChange]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.shippingInstruction.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormikValue(shippingInstruction),
        onSubmit: onSubmit,
        validate: validate,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    var toggleStatus = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var status;
        return __generator(this, function (_a) {
            status = shippingInstruction.status === 'draft' ? 'published' : 'draft';
            confirm('', t("messages.changeContractStatusTo".concat(capitalize(status))), function () { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setLoading(true);
                            return [4 /*yield*/, update({
                                    id: shippingInstruction.id,
                                    shipping_instruction: { status: status },
                                })];
                        case 1:
                            response = _a.sent();
                            setLoading(false);
                            if (!response)
                                return [2 /*return*/];
                            onChange(response);
                            notify('success', [t('messages.updateSuccess')]);
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); }, [shippingInstruction, update, notify, onChange, t, confirm]);
    var statusChangeButtonText = React.useMemo(function () {
        var nextStatus = shippingInstruction.status === 'draft' ? 'published' : 'draft';
        var status = t("params.shippingInstruction.statuses.".concat(nextStatus));
        return t('buttons.changeStatusTo', { status: status });
    }, [t, shippingInstruction.status]);
    var FormikTextField = React.useMemo(function () { return withDefaultProps(OriginalFormikTextField, { disabled: !editable }); }, [editable]);
    var FormikDatePicker = React.useMemo(function () { return withDefaultProps(OriginalFormikDatePicker, { disabled: !editable }); }, [editable]);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 1, marginY: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(Box, { display: "flex", alignItems: "center" },
                    React.createElement(Typography, { variant: "h3" },
                        t('params.shippingInstruction.status'),
                        ":"),
                    React.createElement(StatusTag, { style: {
                            margin: '0 16px',
                            height: 16,
                        }, className: shippingInstruction.status }, t("params.shippingInstruction.statuses.".concat(shippingInstruction.status))),
                    React.createElement(Button, { size: "small", variant: "contained", onClick: toggleStatus }, statusChangeButtonText))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6, textAlign: "right" },
                React.createElement(FormikDatePicker, { name: "date_of_issue", label: t('params.shippingInstruction.dateOfIssue'), required: true, formik: formik }))),
        React.createElement(Grid, { container: true, spacing: 1, marginY: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "h3" }, "Shipper")),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "shipper_company_name", label: t('params.shippingInstruction.shipperCompanyName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "shipper_phone_number", label: t('params.shippingInstruction.shipperPhoneNumber'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "shipper_contact_name", label: t('params.shippingInstruction.shipperContactName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "shipper_email", label: t('params.shippingInstruction.shipperEmail'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "shipper_address", label: t('params.shippingInstruction.shipperAddress'), required: true, formik: formik }))),
        React.createElement(Grid, { container: true, spacing: 1, marginY: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(Typography, { variant: "h3" }, "Consignee")),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, multiline: true, rows: 2, name: "consignee_tax_id_text", label: t('params.shippingInstruction.consigneeTaxIdText'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "consignee_company_name", label: t('params.shippingInstruction.consigneeCompanyName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "consignee_phone_number", label: t('params.shippingInstruction.consigneePhoneNumber'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "consignee_contact_name", label: t('params.shippingInstruction.consigneeContactName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "consignee_email", label: t('params.shippingInstruction.consigneeEmail'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "consignee_address", label: t('params.shippingInstruction.consigneeAddress'), required: true, formik: formik }))),
        React.createElement(Grid, { container: true, spacing: 1, marginY: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(Typography, { variant: "h3" }, "Notify party")),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, multiline: true, rows: 2, name: "notify_party_tax_id_text", label: t('params.shippingInstruction.notifyPartyTaxIdText'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "notify_party_company_name", label: t('params.shippingInstruction.notifyPartyCompanyName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "notify_party_phone_number", label: t('params.shippingInstruction.notifyPartyPhoneNumber'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "notify_party_contact_name", label: t('params.shippingInstruction.notifyPartyContactName'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "notify_party_email", label: t('params.shippingInstruction.notifyPartyEmail'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "notify_party_address", label: t('params.shippingInstruction.notifyPartyAddress'), required: true, formik: formik }))),
        React.createElement(Grid, { container: true, spacing: 1, marginY: 2 }, [
            'shipping_company',
            'on_or_about',
            'booking_number',
            'port_of_loading',
            'ocean_vessel',
            'port_of_discharge',
            'voyage_number',
            'freight',
        ].map(function (field) { return (React.createElement(Grid, { item: true, xs: 12, sm: 6, key: field },
            React.createElement(FormikTextField, { fullWidth: true, required: REQUIRED_FIELDS.includes(field), name: field, label: t("params.shippingInstruction.".concat(camelize(field))), formik: formik }))); })),
        React.createElement(Grid, { container: true, spacing: 1, marginY: 2 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, multiline: true, rows: 4, name: "required_documents", label: t('params.shippingInstruction.requiredDocuments'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, multiline: true, rows: 4, name: "bag_marks", label: t('params.shippingInstruction.bagMarks'), formik: formik }))),
        React.createElement(Grid, { container: true, spacing: 1, marginY: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "h3" }, "Attributes for commercial invoice, packing list")),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "date_of_packing", inputFormat: "MMMM yyyy", label: t('params.shippingInstruction.dateOfPacking'), views: ['year', 'month'], required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "description_of_goods", label: t('params.shippingInstruction.descriptionOfGoods'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "country_of_origin", label: t('params.shippingInstruction.countryOfOrigin'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "crop", label: t('params.shippingInstruction.crop'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "expiration_date", label: t('params.shippingInstruction.expirationDate'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "shipment", inputFormat: "MMMM yyyy", label: t('params.shippingInstruction.shipment'), views: ['year', 'month'], required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "incoterms", label: t('params.shippingInstruction.incoterms'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "payment", label: t('params.shippingInstruction.payment'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "insurance", label: t('params.shippingInstruction.insurance'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "freight_for_invoice_or_packing_list", label: t('params.shippingInstruction.freightForInvoiceOrPackingList'), formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, required: true, name: "total_gross_weight", type: "number", label: t('params.shippingInstruction.totalGrossWeight'), formik: formik }))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: !formik.isValid || !editable || loading }, t('buttons.update'))))));
};
export default ShippingInstructionForm;
var toFormikValue = function (shippingInstruction) { return ({
    status: shippingInstruction.status,
    date_of_issue: shippingInstruction.dateOfIssue,
    shipping_company: shippingInstruction.shippingCompany,
    booking_number: shippingInstruction.bookingNumber,
    ocean_vessel: shippingInstruction.oceanVessel,
    voyage_number: shippingInstruction.voyageNumber,
    on_or_about: shippingInstruction.onOrAbout,
    port_of_loading: shippingInstruction.portOfLoading,
    port_of_discharge: shippingInstruction.portOfDischarge,
    freight: shippingInstruction.freight,
    freight_for_invoice_or_packing_list: shippingInstruction.freightForInvoiceOrPackingList,
    description_of_goods: shippingInstruction.descriptionOfGoods,
    country_of_origin: shippingInstruction.countryOfOrigin,
    crop: shippingInstruction.crop,
    expiration_date: shippingInstruction.expirationDate,
    shipment: shippingInstruction.shipment || '',
    incoterms: shippingInstruction.incoterms,
    payment: shippingInstruction.payment,
    insurance: shippingInstruction.insurance,
    date_of_packing: shippingInstruction.dateOfPacking,
    total_gross_weight: shippingInstruction.totalGrossWeight,
    shipper_company_name: shippingInstruction.shipperCompanyName,
    shipper_contact_name: shippingInstruction.shipperContactName,
    shipper_address: shippingInstruction.shipperAddress,
    shipper_phone_number: shippingInstruction.shipperPhoneNumber,
    shipper_email: shippingInstruction.shipperEmail,
    consignee_company_name: shippingInstruction.consigneeCompanyName,
    consignee_contact_name: shippingInstruction.consigneeContactName,
    consignee_address: shippingInstruction.consigneeAddress,
    consignee_phone_number: shippingInstruction.consigneePhoneNumber,
    consignee_email: shippingInstruction.consigneeEmail,
    consignee_tax_id_text: shippingInstruction.consigneeTaxIdText,
    notify_party_company_name: shippingInstruction.notifyPartyCompanyName,
    notify_party_contact_name: shippingInstruction.notifyPartyContactName,
    notify_party_address: shippingInstruction.notifyPartyAddress,
    notify_party_phone_number: shippingInstruction.notifyPartyPhoneNumber,
    notify_party_email: shippingInstruction.notifyPartyEmail,
    notify_party_tax_id_text: shippingInstruction.notifyPartyTaxIdText,
    required_documents: shippingInstruction.requiredDocuments,
    bag_marks: shippingInstruction.bagMarks,
}); };
